import { reduce } from '../helpers/utils';

const initialState = {
  locale: 'en',
  lang: {}
};

const CHANGE_LOCATION = 'messages/CHANGE_LOCATION';

export default reduce(initialState, {
  [CHANGE_LOCATION](state, action) {
    return {
      ...state,
      locale: action.payload,
      lang: state.translations[action.payload]
    };
  }
});

export function changeLocale(newLocale) {
  return {
    type: CHANGE_LOCATION,
    payload: newLocale
  };
}
